import React from "react";
import BackgroundImage from "gatsby-background-image";
import "@fontsource/dancing-script";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function BannerGallery({ tileImage, featureImage }) {
  return (
    <BackgroundImage
      fluid={tileImage.childImageSharp.fixed}
      style={{
        // Defaults are overwrite-able by setting one or each of the following:
        backgroundSize: "15vw",
        backgroundPosition: "",
        backgroundRepeat: "",
      }}
      className="bg-secondary-light grid grid-cols-5 py-12 lg:py-24 bg-round bg-clip-border"
    >
      <div className="col-span-3">
        <GatsbyImage image={getImage(featureImage)} alt="Goat Lake" />
      </div>

      <div
        className="col-span-2 text-center flex flex-col \
          py-4 p-2 sm:p-8 lg:p-12 xl:p-16 2xl:px-24"
      >
        <h1
          className="flex-grow uppercase text-primary \
            text-xl sm:text-2xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl"
        >
          Plan a Winter Trip to the Desert!
        </h1>
        <p
          className="flex-grow-0 md:flex-grow font-script font-medium \
            sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl \
            hidden md:block"
        >
          Explore the beauty of Utah
        </p>

        <div className="flex-grow-0 w-full flex flex-row justify-center">
          <Link
            to={`/destinations/?f=${encodeURI("UT")}`}
            className="w-2/3 min-w-max bg-secondary p-2 sm:p-4 xl:p-8 flex flex-col justify-center"
          >
            <p
              className="text-center align-middle text-white uppercase \
              text-xs sm:text-xl md:text-2xl lg:text-3xl"
            >
              Utah Guides
            </p>
          </Link>
        </div>
      </div>
    </BackgroundImage>
  );
}
